<template>
  <div
    :class="[
      'c--shared_page-title',
      'page-header-wrapper',
      {
        'mobile-header-wrapper': deviceType.isMobile,
        'border-md-b border-md-b-solid color-border-bottom-light': !deviceType.isMobile && bordered,
      },
    ]"
  >
    <div
      :class="[
        'page-header relative pb-20',
        {
          'pb-sm-30 pb-lg-40': !deviceType.isMobile,
        },
      ]"
    >
      <div class="airgsm-container page-header-title relative">
        <template v-if="backButton">
          <nuxt-link
            :to="localePath(backButton.url)"
            :class="[
              'page-header-title-back',
              {
                'display-inline-flex': deviceType.isMobile,
                'display-sm-none': backButton.hiddenAfterSizes === 'sm' && !deviceType.isMobile,
                'display-md-none': backButton.hiddenAfterSizes === 'md' && !deviceType.isMobile,
                'display-lg-none': backButton.hiddenAfterSizes === 'lg' && !deviceType.isMobile,
              },
            ]"
          >
            <a-icon type="image" loader="data" name="ic_back_header" theme="light" />
          </nuxt-link>
        </template>
        <h2
          v-if="titleTag === 'h2'"
          :class="[
            'text-center mb-0',
            {
              'typo-page-title-small px-20': deviceType.isMobile,
              'typo-sm-page-title-medium typo-md-page-title-big px-20 px-sm-48': !deviceType.isMobile,
              ...(isGeneralHeadTitle && { 'general-title': isGeneralHeadTitle }),
            },
          ]"
        >
          {{ title }}
        </h2>
        <h1
          v-else
          :class="[
            'text-center mb-0',
            {
              'typo-page-title-small px-20': deviceType.isMobile,
              'typo-sm-page-title-medium typo-md-page-title-big px-20 px-sm-48': !deviceType.isMobile,
              ...(isGeneralHeadTitle && { 'general-title': isGeneralHeadTitle }),
            },
          ]"
          :data-testid="`${title}-title`"
        >
          {{ title }}
        </h1>
      </div>
      <slot name="subTitle"></slot>
    </div>
    <slot name="bottom" />
  </div>
</template>

<script>
  export default {
    name: 'PageTitle',

    props: {
      title: {
        type: String,
        required: false,
        default: '',
      },
      titleTag: {
        type: String,
        required: false,
        default: 'h1',
      },
      backButton: {
        type: Object,
        required: false,
        default: null,
      },
      isGeneralHeadTitle: {
        type: Boolean,
        required: false,
        default: false,
      },
      bordered: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    computed: {
      deviceType() {
        return this.$store.getters.get_device_types
      },
    },
  }
</script>

<style lang="scss" scoped>
  .page-header {
    width: 100%;

    &-wrapper {
      background-color: #ffffff;

      &.bottom-border {
        border-bottom: 1px solid #ddd;
      }

      &.mobile-header-wrapper {
        position: relative;

        & > * {
          position: relative;
          z-index: 12;
        }

        &::before,
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
        }

        &::before {
          height: 100%;
          background-color: #ffffff;
          z-index: 11;
        }

        &:after {
          height: 50%;
          box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.15);
          z-index: 10;
        }
      }
    }

    &-title {
      &-back {
        position: absolute;
        left: 20px;
        top: 50%;
        transform: rotate(-180deg) translateY(50%);

        [dir='rtl'] & {
          left: unset;
          right: 20px;
          transform: rotate(0deg) translateY(-50%);
        }
      }
    }
  }
</style>
